import { IAccountCredit } from "./accountCredit.type"

export class AccountCredit implements IAccountCredit {
  id: number
  transactionReference: string
  reference: string
  reason: string

  constructor(
    id: number,
    transactionReference: string,
    reference: string,
    reason: string,
  ) {
    this.id = id
    this.transactionReference = transactionReference
    this.reference = reference
    this.reason = reason
  }
}
